<template>
  <div class="ca-planes">
    <header class="ca-cabecera">
      <div>
        <h1 class="ca-titulo">Planes de suscripcion</h1>
        <p class="ca-subtitulo">Define planes y los submodulos incluidos en cada uno.</p>
      </div>
      <button class="ca-boton ca-boton--primario" @click="abrirNuevoPlan">
        <i class="bi bi-plus-lg"></i> Nuevo plan
      </button>
    </header>

    <div v-if="cargando" class="ca-info">Cargando...</div>
    <div v-else-if="!planes.length" class="ca-info">No hay planes registrados.</div>

    <article v-for="p in planes" :key="p.id" class="ca-card">
      <div class="ca-card__header">
        <div class="ca-card__titulo">
          <strong>{{ p.nombre }}</strong>
          <span class="ca-codigo">{{ p.codigo }}</span>
          <span class="ca-badge ca-badge--info">{{ p.periodo }}</span>
          <span class="ca-precio">${{ Number(p.costo).toFixed(2) }}</span>
          <span v-if="!Number(p.activo)" class="ca-badge ca-badge--neutro">inactivo</span>
        </div>
        <div class="ca-card__acciones">
          <button class="ca-boton ca-boton--xs ca-boton--secundario" @click="editarPlan(p)" title="Editar"><i class="bi bi-pencil"></i></button>
          <button class="ca-boton ca-boton--xs ca-boton--secundario" @click="abrirSubmodulosPlan(p)" title="Submodulos"><i class="bi bi-grid-3x3-gap"></i> {{ p.total_submodulos || 0 }}</button>
          <button class="ca-boton ca-boton--xs ca-boton--peligro" @click="eliminarPlan(p)" title="Eliminar"><i class="bi bi-trash"></i></button>
        </div>
      </div>
      <p v-if="p.descripcion" class="ca-card__descripcion">{{ p.descripcion }}</p>
      <div class="ca-card__meta">
        <span><i class="bi bi-clock-history"></i> {{ p.dias_gracia }} dias de gracia</span>
        <span><i class="bi bi-phone"></i> Acceso movil: {{ Number(p.acceso_movil) ? 'si' : 'no' }}</span>
      </div>
    </article>

    <!-- Modal plan -->
    <div v-if="modalPlan" class="ca-modal-fondo" @click.self="modalPlan = null">
      <div class="ca-modal">
        <h2>{{ modalPlan.id ? 'Editar plan' : 'Nuevo plan' }}</h2>
        <div class="ca-grid-2">
          <label>Codigo<input v-model="modalPlan.codigo" class="ca-input"/></label>
          <label>Nombre<input v-model="modalPlan.nombre" class="ca-input"/></label>
        </div>
        <label>Descripcion<textarea v-model="modalPlan.descripcion" class="ca-input" rows="2"></textarea></label>
        <div class="ca-grid-3">
          <label>Periodo principal
            <select v-model="modalPlan.periodo" class="ca-input">
              <option value="mensual">Mensual</option>
              <option value="trimestral">Trimestral</option>
              <option value="anual">Anual</option>
            </select>
          </label>
          <label>Costo (referencia)<input v-model.number="modalPlan.costo" type="number" step="0.01" min="0" class="ca-input"/></label>
          <label>Dias gracia<input v-model.number="modalPlan.dias_gracia" type="number" min="0" class="ca-input"/></label>
        </div>
        <div class="ca-grid-3">
          <label>Precio mensual<input v-model.number="modalPlan.precio_mensual" type="number" step="0.01" min="0" class="ca-input"/></label>
          <label>Precio trimestral<input v-model.number="modalPlan.precio_trimestral" type="number" step="0.01" min="0" class="ca-input"/></label>
          <label>Precio anual<input v-model.number="modalPlan.precio_anual" type="number" step="0.01" min="0" class="ca-input"/></label>
        </div>
        <p class="ca-subtitulo" style="margin:-2px 0 8px">Precios sin IVA por ciclo de facturacion. Se factura segun el ciclo elegido al emitir.</p>
        <div class="ca-grid-2">
          <label class="ca-check"><input v-model="modalPlan.acceso_movil" type="checkbox"/> Acceso movil</label>
          <label class="ca-check"><input v-model="modalPlan.activo" type="checkbox"/> Activo</label>
        </div>
        <div class="ca-modal__acciones">
          <button class="ca-boton ca-boton--secundario" @click="modalPlan = null">Cancelar</button>
          <button class="ca-boton ca-boton--primario" @click="guardarPlan" :disabled="guardando">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Modal submodulos del plan -->
    <div v-if="modalSubmodulos" class="ca-modal-fondo" @click.self="cerrarModalSubmodulos">
      <div class="ca-modal ca-modal--ancho">
        <h2>Submodulos incluidos en "{{ modalSubmodulos.plan.nombre }}"</h2>
        <p class="ca-subtitulo">Selecciona los submodulos que estaran disponibles para empresas con este plan.</p>

        <div v-if="!modulosCatalogo.length" class="ca-info">Cargando catalogo...</div>
        <div v-else class="ca-arbol">
          <div v-for="m in modulosCatalogo" :key="m.id" class="ca-arbol__modulo">
            <label class="ca-arbol__modulo-header">
              <input type="checkbox" :checked="todosMarcados(m)" :indeterminate.prop="algunosMarcados(m)" @change="alternarModulo(m, $event.target.checked)"/>
              <strong>{{ m.nombre }}</strong>
            </label>
            <div class="ca-arbol__submodulos">
              <label v-for="s in m.submodulos" :key="s.id" class="ca-arbol__submodulo">
                <input type="checkbox" :value="s.id" v-model="modalSubmodulos.seleccionados"/>
                {{ s.nombre }}
                <code class="ca-ruta">{{ s.ruta }}</code>
              </label>
            </div>
          </div>
        </div>

        <div class="ca-modal__acciones">
          <button class="ca-boton ca-boton--secundario" @click="cerrarModalSubmodulos">Cancelar</button>
          <button class="ca-boton ca-boton--primario" @click="guardarSubmodulosPlan" :disabled="guardando">Guardar</button>
        </div>
      </div>
    </div>

    <!-- Confirmacion -->
    <div v-if="confirmacion" class="ca-modal-fondo" @click.self="confirmacion = null">
      <div class="ca-modal ca-modal--confirm">
        <h2>{{ confirmacion.titulo }}</h2>
        <p>{{ confirmacion.mensaje }}</p>
        <div class="ca-modal__acciones">
          <button class="ca-boton ca-boton--secundario" @click="confirmacion = null">Cancelar</button>
          <button class="ca-boton ca-boton--peligro" @click="ejecutarConfirmacion">Eliminar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import controlAcceso from '@/services/controlAccesoService'
import { notifySuccess, notifyError } from '@/services/notificationService'

export default {
  name: 'ControlAccesoPlanes',
  data() {
    return {
      cargando: false,
      guardando: false,
      planes: [],
      modulosCatalogo: [],
      modalPlan: null,
      modalSubmodulos: null,
      confirmacion: null,
    }
  },
  mounted() { this.cargar() },
  methods: {
    async cargar() {
      this.cargando = true
      try {
        const res = await controlAcceso.listarPlanes()
        this.planes = res.data || []
      } catch (e) {
        notifyError('No se pudieron cargar los planes.')
      } finally { this.cargando = false }
    },
    abrirNuevoPlan() {
      this.modalPlan = {
        codigo: '', nombre: '', descripcion: '',
        costo: 0, periodo: 'mensual', dias_gracia: 7,
        precio_mensual: 0, precio_trimestral: 0, precio_anual: 0,
        acceso_movil: true, activo: true,
      }
    },
    editarPlan(p) {
      this.modalPlan = { ...p, acceso_movil: !!Number(p.acceso_movil), activo: !!Number(p.activo) }
    },
    async guardarPlan() {
      const p = this.modalPlan
      if (!p.codigo || !p.nombre) { notifyError('Codigo y nombre son obligatorios.'); return }
      this.guardando = true
      try {
        if (p.id) await controlAcceso.actualizarPlan(p.id, p)
        else      await controlAcceso.crearPlan(p)
        notifySuccess('Plan guardado.')
        this.modalPlan = null
        await this.cargar()
      } catch (e) {
        notifyError(e?.response?.data?.error || 'Error al guardar el plan.')
      } finally { this.guardando = false }
    },
    eliminarPlan(p) {
      this.confirmacion = {
        titulo: 'Eliminar plan',
        mensaje: `Se eliminara "${p.nombre}" y sus asignaciones de submodulos. Las suscripciones existentes mantendran su referencia hasta que se borren.`,
        accion: async () => {
          try {
            await controlAcceso.eliminarPlan(p.id)
            notifySuccess('Plan eliminado.')
            await this.cargar()
          } catch (e) {
            notifyError(e?.response?.data?.error || 'No se pudo eliminar.')
          }
        },
      }
    },
    async abrirSubmodulosPlan(p) {
      try {
        if (!this.modulosCatalogo.length) {
          const cat = await controlAcceso.listarModulos()
          this.modulosCatalogo = cat.data || []
        }
        const detalle = await controlAcceso.obtenerPlan(p.id)
        this.modalSubmodulos = { plan: p, seleccionados: detalle.data?.submodulos || [] }
      } catch (e) {
        notifyError('No se pudo cargar la asignacion del plan.')
      }
    },
    cerrarModalSubmodulos() { this.modalSubmodulos = null },
    todosMarcados(m) {
      if (!m.submodulos.length) return false
      return m.submodulos.every(s => this.modalSubmodulos.seleccionados.includes(s.id))
    },
    algunosMarcados(m) {
      const sel = this.modalSubmodulos.seleccionados
      const algunos = m.submodulos.some(s => sel.includes(s.id))
      const todos = this.todosMarcados(m)
      return algunos && !todos
    },
    alternarModulo(m, marcar) {
      const ids = m.submodulos.map(s => s.id)
      const sel = new Set(this.modalSubmodulos.seleccionados)
      ids.forEach(id => marcar ? sel.add(id) : sel.delete(id))
      this.modalSubmodulos.seleccionados = [...sel]
    },
    async guardarSubmodulosPlan() {
      this.guardando = true
      try {
        await controlAcceso.setSubmodulosPlan(this.modalSubmodulos.plan.id, this.modalSubmodulos.seleccionados)
        notifySuccess('Submodulos del plan actualizados.')
        this.modalSubmodulos = null
        await this.cargar()
      } catch (e) {
        notifyError(e?.response?.data?.error || 'Error al guardar.')
      } finally { this.guardando = false }
    },
    async ejecutarConfirmacion() {
      const accion = this.confirmacion?.accion
      this.confirmacion = null
      if (accion) await accion()
    },
  },
}
</script>

<style scoped>
.ca-planes { color: var(--text-primary); }
.ca-cabecera { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 18px; gap: 16px; }
.ca-titulo { font-size: 1.4rem; margin: 0; }
.ca-subtitulo { margin: 4px 0 0; color: var(--text-secondary); font-size: 0.9rem; }

.ca-card {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: var(--shadow-sm);
}
.ca-card__header { display: flex; justify-content: space-between; align-items: center; gap: 12px; }
.ca-card__titulo { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
.ca-card__acciones { display: flex; gap: 6px; }
.ca-card__descripcion { color: var(--text-secondary); font-size: 0.88rem; margin: 8px 0 4px; }
.ca-card__meta { display: flex; gap: 18px; color: var(--text-secondary); font-size: 0.82rem; margin-top: 6px; }
.ca-precio { color: var(--accent-success); font-weight: 600; }

.ca-codigo {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 6px;
  background: var(--bg-main);
  color: var(--text-secondary);
  font-size: 0.78rem;
  font-family: ui-monospace, monospace;
}
.ca-ruta { color: var(--text-muted); font-size: 0.78rem; margin-left: 6px; }

.ca-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: lowercase;
}
.ca-badge--info   { background: color-mix(in srgb, var(--primary-main) 18%, transparent); color: var(--primary-main); }
.ca-badge--neutro { background: var(--bg-main); color: var(--text-muted); }

.ca-info { padding: 14px; color: var(--text-secondary); }

.ca-boton {
  border: 1px solid var(--border-main);
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.88rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s, border-color 0.15s;
}
.ca-boton:hover:not(:disabled) { background: var(--bg-main); }
.ca-boton:disabled { opacity: 0.6; cursor: not-allowed; }
.ca-boton--xs { padding: 4px 8px; font-size: 0.78rem; }
.ca-boton--primario   { background: var(--primary-main); border-color: var(--primary-main); color: #fff; }
.ca-boton--primario:hover:not(:disabled) { background: var(--primary-hover); border-color: var(--primary-hover); }
.ca-boton--secundario { background: transparent; }
.ca-boton--peligro    { color: var(--accent-danger); border-color: color-mix(in srgb, var(--accent-danger) 40%, transparent); }
.ca-boton--peligro:hover:not(:disabled) { background: color-mix(in srgb, var(--accent-danger) 12%, transparent); }

.ca-modal-fondo { position: fixed; inset: 0; z-index: 2000; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; }
.ca-modal {
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-radius: 12px;
  padding: 22px;
  min-width: 420px;
  max-width: 560px;
  border: 1px solid var(--border-main);
  box-shadow: var(--shadow-md);
}
.ca-modal--ancho { min-width: 640px; max-width: 760px; max-height: 80vh; overflow-y: auto; }
.ca-modal h2 { font-size: 1.1rem; margin: 0 0 16px; }
.ca-modal label { display: block; margin-bottom: 10px; font-size: 0.85rem; color: var(--text-secondary); }
.ca-modal__acciones { display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px; }
.ca-modal--confirm p { color: var(--text-secondary); margin-bottom: 12px; }

.ca-input {
  width: 100%;
  background: var(--bg-main);
  color: var(--text-primary);
  border: 1px solid var(--border-main);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 0.92rem;
  margin-top: 4px;
}
.ca-input:focus { outline: none; border-color: var(--border-focus); }
.ca-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.ca-grid-3 { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 12px; }
.ca-check { display: inline-flex; align-items: center; gap: 8px; }
.ca-check input { transform: scale(1.05); }

.ca-arbol { border: 1px solid var(--border-main); border-radius: 8px; padding: 10px; max-height: 50vh; overflow-y: auto; }
.ca-arbol__modulo { padding: 6px 0; border-bottom: 1px dashed var(--border-main); }
.ca-arbol__modulo:last-child { border-bottom: 0; }
.ca-arbol__modulo-header { display: flex; align-items: center; gap: 8px; padding: 4px 0; }
.ca-arbol__submodulos { display: flex; flex-wrap: wrap; gap: 8px 16px; padding: 6px 0 6px 24px; }
.ca-arbol__submodulo { display: inline-flex; align-items: center; gap: 6px; font-size: 0.86rem; color: var(--text-secondary); }
</style>
